// extracted by mini-css-extract-plugin
export default {"boxes_rounded":"Journal_boxes_rounded__98zUt"};